// ======================================================================
// File Name       : JoinableLiveList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React from 'react';
import { Col, Table } from 'react-bootstrap';
import Header from '../../components/Header';
import { MEETING_VCUBE_CONNECTION_CHECK_URL, MEETING_VCUBE_QA_URL } from '../../constants/index';
import {
  convertLiveFormatType,
  getLiveStartTimeDiv,
} from '../../utils/UsageSettingLiveUtils';

class JoinableLiveList extends React.Component {
  render() {
    let tbody = null;
    const now = moment().startOf('minute');
    const { userSecernId, liveList } = this.props;
    if (liveList && liveList.length) {
      tbody = liveList.map((liveItem, index) => {
        const { liveStartFrom, liveStartTo, liveName, liveFormat, liveUrl, liveSituation } = liveItem;
        const enabled = liveSituation === 1;
        return (
          <tr key={index}>
            <td>{getLiveStartTimeDiv(liveStartFrom, liveStartTo)}</td>
            <td>{convertLiveFormatType(liveFormat)}</td>
            <td>{liveName}</td>
            <td>
              <div className="float-right">
                <a
                  className="btn btn-primary btn-96"
                  disabled={!enabled}
                  role="button"
                  href={enabled ? liveUrl : '#'}
                  target={enabled ? '_blank' : ''}
                >
                  入室
                </a>
              </div>
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Col sm={12} className="padding-left-clear">
          <Col
            sm={12}
            className="padding-left-right-10"
            style={{ border: '1px solid #ccc', paddingTop: '10px' }}
          >
            <Col sm={12} className="padding-left-right-10">
              <Col sm={3} className="padding-left-clear">
                <Header name="参加ライブ一覧" />
              </Col>
              <Col
                sm={{
                  span: 6,
                  offset: 3
                }}
                className="padding-right-clear">
                <a
                  className="float-end"
                  role="button"
                  href={`${MEETING_VCUBE_QA_URL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u>ライブQA</u>
                </a>
              </Col>
            </Col>
            <Col sm={12} className="padding-left-right-10">
              <Col
                sm={{
                  span: 6,
                  offset: 6
                }}
                className="padding-right-clear">
                <a
                  className="float-end"
                  role="button"
                  href={`${MEETING_VCUBE_CONNECTION_CHECK_URL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u>機器接続確認について</u> {/* #7135 */}
                </a>
              </Col>
            </Col>
            {!tbody && (
              <Col sm={12} className="margin-top-10 margin-left-20 margin-bottom-10">
                参加可能ライブがありません
              </Col>
            )}
            {tbody && (
              <Table className="table-no-border">
                <thead style={{ background: 'none', color: '#333', fontWeight: 'bold' }}>
                  <tr>
                    <td width={150}>開始日時</td>
                    <td width={150}>ライブ形式</td>
                    <td width={420}>ライブ名</td>
                    <td />
                  </tr>
                </thead>
                <tbody>{tbody}</tbody>
              </Table>
            )}
          </Col>
        </Col>
      </div>
    );
  }
}

export default JoinableLiveList;
